import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Scissors } from "lucide-react";
import ServiziSelector from "./ServiziSelector";

/**
 * Dialog di selezione servizi (vista a CATEGORIE come in Agenda) usato nella Cassa.
 * Estratto da Cassa.jsx per ridurne le dimensioni.
 */
export default function CassaServiziDialog({
  open,
  onOpenChange,
  servizi,
  serviziAggiunti,
  prezziModificati,
  onToggle,
  onConferma,
}) {
  const subtotale = serviziAggiunti.reduce(
    (s, srv) => s + (parseFloat(prezziModificati[srv.idx]) || parseFloat(srv.prezzo) || 0),
    0
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[95vw] sm:max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="cassa-servizi-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg">
            <Scissors className="w-5 h-5 text-blue-600" />
            Aggiungi Servizi al Conto
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-xs text-slate-500">
            Tocca un servizio per aggiungerlo al conto. Tocca di nuovo per rimuoverlo. Tutti i servizi verranno conteggiati nei report.
          </p>
          <ServiziSelector
            servizi={servizi}
            selectedServizi={serviziAggiunti}
            onToggle={onToggle}
          />
          <div className="flex justify-between items-center pt-2 border-t">
            <p className="text-sm text-slate-600">
              <span className="font-bold text-blue-600">{serviziAggiunti.length}</span> servizi aggiunti
              {serviziAggiunti.length > 0 && (
                <span className="ml-2 text-slate-400">
                  · +€{subtotale.toFixed(2)}
                </span>
              )}
            </p>
            <Button
              onClick={onConferma}
              className="bg-blue-600 hover:bg-blue-700 text-white"
              data-testid="cassa-servizi-dialog-conferma"
            >
              Conferma
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
